export default __webpack_public_path__ + "static/media/LinkedIn-Elogiar-Reconhecer-Colega-14.cd7efddd.jpg";